import { useEffect, useRef } from "react"
import { useLocation, useSearchParams } from "react-router-dom"

const openedOnboardingCreateKeys = new Set<string>()

export const useOnboardingCreatePopup = (openCreatePopup?: () => void) => {
  const location = useLocation()

  const [searchParams] = useSearchParams()

  const lastOpenKeyRef = useRef("")

  useEffect(() => {
    const shouldOpen = searchParams.get("onboardingCreate") === "true"

    if (!shouldOpen) {
      lastOpenKeyRef.current = ""

      return
    }

    if (!openCreatePopup) {
      return
    }

    const openKey = `${location.key}:${location.pathname}:${location.search}`

    if (lastOpenKeyRef.current === openKey || openedOnboardingCreateKeys.has(openKey)) {
      return
    }

    openedOnboardingCreateKeys.add(openKey)

    lastOpenKeyRef.current = openKey

    openCreatePopup()
  }, [location.key, location.pathname, location.search, openCreatePopup, searchParams])
}
